import { Condition, ConditionType, Filters } from "@tenforce/product-fields"

import { FiltersDTO } from "../../models/dto/filters"
import { ConditionDTO, ConditionDTOType } from "../../models/dto/conditions"

import TextConditionParser from "./TextConditionParser"
import DecimalConditionParser from "./DecimalConditionParser"
import BooleanConditionParser from "./BooleanConditionParser"

export interface FilterParser {
    Type: ConditionType
    TypeDTO: ConditionDTOType
    checkIfApplicable: (condition: Condition) => boolean
    checkIfApplicableDTO: (condition: ConditionDTO) => boolean
    parseFromDTO: (condition: ConditionDTO) => Condition
    parseToDTO: (id: string, condition: Condition) => ConditionDTO | null
}

const parseFromDTOParsers = {
    [TextConditionParser.TypeDTO]: TextConditionParser.parseFromDTO,
    [DecimalConditionParser.TypeDTO]: DecimalConditionParser.parseFromDTO,
    [BooleanConditionParser.TypeDTO]: BooleanConditionParser.parseFromDTO,
    // Add other parsers here
}

const parseToDTOParsers = {
    [TextConditionParser.Type]: TextConditionParser.parseToDTO,
    [DecimalConditionParser.Type]: DecimalConditionParser.parseToDTO,
    [BooleanConditionParser.Type]: BooleanConditionParser.parseToDTO,
    // Add other parsers here
}

export const parseFromDTO = (dto: FiltersDTO): Filters => {
    return (
        dto.Conditions.reduce((acc, condition) => {
            const parsed = parseFromDTOParsers[condition["@type"]]?.(condition)
            if (parsed && condition?.FieldDefinition?.Id) {
                return { ...acc, [condition.FieldDefinition.Id]: parsed }
            } else {
                return acc
            }
        }, {} as Filters) ?? {}
    )
}

export const parseToDTO = (filters: Filters): FiltersDTO => {
    return {
        "@type": "#TF.LogicalAnd",
        Conditions: Object.entries(filters)
            .map((entry) => {
                const [id, condition] = entry
                if (!condition) {
                    return
                }
                return (
                    parseToDTOParsers[condition.type]?.(id, condition) ?? null
                )
            })
            .filter((condition) => condition !== null) as ConditionDTO[],
    }
}
